Gift =
  init: (payload, done) ->
    @cookieDomain = payload?.giftButton?.cookieDomain

    @bindGiftButton()
    done()

  bindGiftButton: ->
    $gift_button  = $('.gift-button')

    if $gift_button.length > 0
      $gift_button.on('click', (e) =>
        e.preventDefault()
        @createCookie()

        BuyButton.eventBus.go 'buy_button_clicked'
      )

  createCookie: ->
    Cookie.set('modalForGiftOnLoad','true',60, @cookieDomain)
    @cookieCreated = true

  removeCookie: ->
    Cookie.unset('modalForGiftOnLoad', @cookieDomain)
    @cookieCreated = false

module.exports = Gift
